<div class="flex flex-wrap gap-4 items-center p-4 bg-gray-50 rounded-lg">
  <div class="flex flex-col">
    <label for="dataInicial" class="block text-sm font-medium text-gray-700">Data Inicial</label>
    <input
      type="date"
      id="dataInicial"
      [(ngModel)]="dataInicial"
      (change)="onDataChange()"
      class="mt-1 block w-full md:w-auto p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>

  <div class="flex flex-col">
    <label for="dataFinal" class="block text-sm font-medium text-gray-700">Data Final</label>
    <input
      type="date"
      id="dataFinal"
      [(ngModel)]="dataFinal"
      (change)="onDataChange()"
      class="mt-1 block w-full md:w-auto p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>

  <div class="flex flex-col">
    <label for="vendedor" class="block text-sm font-medium text-gray-700">Vendedor</label>
    <p-dropdown
      data-testid="vendedor-dropdown"
      [options]="vendedores"
      optionLabel="nome"
      optionValue="id"
      [(ngModel)]="selectedVendedorId"
      (onChange)="onFiltroChange()"
      name="vendedor"
      placeholder="Selecione um vendedor"
      styleClass="w-full md:w-auto"
      [showClear]="true"
    ></p-dropdown>
  </div>

  <div class="flex flex-col">
    <label for="status" class="block text-sm font-medium text-gray-700">Status</label>
    <p-dropdown
      [options]="statusOptions"
      [(ngModel)]="selectedStatus"
      (onChange)="onFiltroChange()"
      placeholder="Selecione um status"
      styleClass="w-full md:w-auto"
      [showClear]="true"
    ></p-dropdown>
  </div>

  <div class="flex items-end">
    <button
      (click)="limparFiltros()"
      class="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
    >
      Limpar Filtros
    </button>
  </div>
</div>

<div class="mx-auto p-4 md:p-8 bg-white rounded-lg shadow-sm flex flex-col space-y-4">
  <div class="flex-1 bg-white rounded-lg">
    <h1 class="text-xl font-semibold">Vendas</h1>

    <div class="overflow-x-auto w-full space-y-4">
      <p-table [value]="vendas" class="w-full mt-6">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-2 border-b text-left">Id</th>
            <th class="p-2 border-b text-left">Cliente</th>
            <th class="p-2 border-b text-left">Situação</th>
            <th class="p-2 border-b text-left">Usuário</th>
            <th class="p-2 border-b text-left">Vendedor</th>
            <th class="p-2 border-b text-left">Valor Total</th>
            <th class="p-2 border-b text-left">Pagamento</th>
            <th class="p-2 border-b text-left">Observação</th>
            <th class="p-2 border-b text-left">Data Cadastro</th>
            <th class="p-2 border-b text-left">Data Última Modificação</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-venda>
          <tr class="hover:bg-gray-100 cursor-pointer" (click)="selecionarVenda(venda)">
            <td class="p-2 border-b">{{ venda.id }}</td>
            <td class="p-2 border-b">{{ venda.cliente?.nome }}</td>
            <td class="p-2 border-b">
              <span [ngClass]="{
                'inline-block px-2 py-1 rounded text-sm font-semibold': true,
                'bg-red-100 text-red-800 border border-red-200': venda.vendaSituacao === 'CANCELADA',
                'bg-green-100 text-green-800 border border-green-200': venda.vendaSituacao === 'VENDA_FECHADA',
                'bg-yellow-100 text-yellow-800 border border-yellow-200': venda.vendaSituacao === 'VENDA_ABERTA',
                'bg-blue-100 text-blue-800 border border-blue-200': venda.vendaSituacao === 'ORCAMENTO'
              }">
                {{ getStatusLabel(venda.vendaSituacao) }}
              </span>
            </td>
            <td class="p-2 border-b">{{ venda.usuario?.username }}</td>
            <td class="p-2 border-b">{{ venda.vendedor?.nome?.split(' ')[0] }}</td>
            <td class="p-2 border-b">{{ venda.valorTotal | currency:'BRL' }}</td>
            <td class="p-2 border-b">{{ venda.pagamento }}</td>
            <td class="p-2 border-b">{{ venda.observacao }}</td>
            <td class="p-2 border-b">{{ venda.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}</td>
            <td class="p-2 border-b">{{ venda.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div *ngIf="vendaSelecionada" class="mt-4">
    <h2 class="text-lg font-semibold">Itens da Venda: {{ vendaSelecionada.id }}</h2>
    <div class="overflow-x-auto">
      <p-table [value]="vendaSelecionada.itens" class="w-full mt-6">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-2 border-b text-left">Id</th>
            <th class="p-2 border-b text-left">Produto</th>
            <th class="p-2 border-b text-left">Quantidade</th>
            <th class="p-2 border-b text-left">Preço</th>
            <th class="p-2 border-b text-left">Desconto</th>
            <th class="p-2 border-b text-left">Acréscimo</th>
            <th class="p-2 border-b text-left">Total</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-itemVenda>
          <tr>
            <td class="p-2 border-b">{{ itemVenda.produto.id }}</td>
            <td class="p-2 border-b">{{ itemVenda.produto.nome }}</td>
            <td class="p-2 border-b">{{ itemVenda.quantidade }}</td>
            <td class="p-2 border-b">{{ itemVenda.produto.preco | currency:'BRL' }}</td>
            <td class="p-2 border-b">{{ itemVenda.valorDesconto | currency:'BRL' }}</td>
            <td class="p-2 border-b">{{ itemVenda.valorAcrescimo | currency:'BRL' }}</td>
            <td class="p-2 border-b">{{ itemVenda.valorTotal | currency:'BRL' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="mt-4 text-right">
    <p><strong>Total dos itens filtrados: {{ totalValorItens | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong></p>
  </div>
</div>
